var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#FFCECF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12451_6582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.019 8.01071C27.7353 8.58821 27.4859 11.1366 27.4859 11.1366C27.4859 11.1366 26.0662 9.01039 23.7649 9.59446C22.0368 10.032 20.4115 11.9023 21.9274 14.8313C23.4434 17.7626 29.8046 20.2826 29.8046 20.2826C29.8046 20.2826 34.184 15.0435 34.1249 11.7448C34.0637 8.44602 31.8871 7.53821 30.019 8.01071Z",
    fill: "#EF5592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4719 9.91372C25.2657 9.46091 26.6438 11.1628 27.1294 11.8715C27.1994 11.9722 27.3547 11.9372 27.3744 11.8168L27.5057 10.9965C26.8363 9.90716 25.5041 9.15247 23.765 9.59216C23.0453 9.77372 22.3453 10.2047 21.8816 10.8543C22.3169 10.3818 22.8878 10.0625 23.4719 9.91372Z",
    fill: "#DA2E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0191 8.0106C29.4679 8.1506 28.9954 8.39779 28.665 8.73904C28.9144 8.56404 29.2491 8.45466 29.586 8.36935C31.2769 7.9406 33.0663 8.7981 32.9679 11.9328C32.8782 14.7853 29.3804 20.1031 29.3804 20.1031L29.8069 20.2803C29.8069 20.2803 34.1841 15.0434 34.125 11.7447C34.0638 8.44591 31.8916 7.53591 30.0191 8.0106Z",
    fill: "#DA2E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7543 11.2394C23.135 10.7188 23.8393 10.2725 24.4693 10.7253C24.8106 10.9703 24.6881 11.5084 24.4037 11.7447C23.9881 12.0903 23.6206 12.3025 23.3822 12.8253C23.2378 13.1403 23.1568 13.4794 23.124 13.825C23.1109 13.9606 22.9359 14.0022 22.8637 13.8863C22.3737 13.0988 22.1987 11.9984 22.7543 11.2394Z",
    fill: "#F386AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9647 10.8019C28.7766 10.8216 28.6234 10.6553 28.6737 10.4716C28.7678 10.1347 28.8969 9.80438 29.0653 9.50469C29.3147 9.06282 29.8462 8.76313 30.2247 8.97313C30.6141 9.18969 30.6206 9.70376 30.3931 9.97719C29.9075 10.5634 29.2359 10.7734 28.9647 10.8019Z",
    fill: "#F386AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6288 19.9434C22.2732 17.9747 19.0313 20.6784 19.0313 20.6784C19.0313 20.6784 19.8276 16.5375 16.4501 14.5556C13.9126 13.0659 9.83727 13.3766 8.2229 18.5762C6.60852 23.7759 11.1563 34.1075 11.1563 34.1075C11.1563 34.1075 22.3673 33.0312 26.121 29.0872C29.8748 25.1431 28.3698 21.5534 25.6288 19.9434Z",
    fill: "#EF5592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7303 14.5928C18.3619 16.1394 18.0075 19.7357 17.7559 21.1313C17.7209 21.3303 17.9441 21.4703 18.1081 21.35L19.0225 20.6763C19.4994 18.6222 18.9984 16.0541 16.4478 14.5557C15.3934 13.9366 14.07 13.6303 12.7706 13.8557C13.8338 13.801 14.875 14.0897 15.7303 14.5928Z",
    fill: "#DA2E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6288 19.9434C24.8194 19.4688 23.9772 19.2106 23.1941 19.2281C23.6884 19.3091 24.2091 19.5694 24.7056 19.8603C27.1863 21.3172 28.3019 24.5022 24.7472 28.2625C21.6956 31.4913 14.0088 33.0684 11.4581 33.8953C11.2963 33.9478 11.1584 34.1053 11.1584 34.1053C11.1584 34.1053 22.3694 33.0291 26.1231 29.085C29.8747 25.1431 28.3741 21.5578 25.6288 19.9434Z",
    fill: "#DA2E75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4228 15.4547C13.4181 15.0762 14.7896 15.085 15.2578 16.2772C15.5115 16.9225 14.8618 17.5569 14.2537 17.6291C13.3678 17.7341 12.6699 17.7034 11.8693 18.2131C11.3881 18.5194 10.9724 18.9197 10.6181 19.3681C10.4781 19.5453 10.1981 19.4447 10.2024 19.2194C10.2309 17.6925 10.9724 16.0081 12.4228 15.4547Z",
    fill: "#F386AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.742 22.365C20.4729 22.2075 20.4358 21.8335 20.6808 21.6431C21.1336 21.2888 21.6323 20.9781 22.1508 20.7463C22.9142 20.405 23.9139 20.5297 24.2114 21.1838C24.5154 21.8531 24.0189 22.5422 23.4501 22.68C22.2251 22.9753 21.1292 22.5925 20.742 22.365Z",
    fill: "#F386AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12451_6582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIcon);
export default __webpack_public_path__ + "static/media/love-icon.6cea7c76120c33f0e70f0d11397b80d5.svg";
export { ForwardRef as ReactComponent };